export type ChatRequestErrorKind = "unexpected" | "contentFilter" | "contextLength" | "access";

export class ChatRequestError extends Error {
    readonly kind: ChatRequestErrorKind;

    constructor(kind: ChatRequestErrorKind) {
        super(kind);
        this.name = "ChatRequestError";
        this.kind = kind;
    }
}

export function chatRequestErrorFromPayload(payload: unknown, status?: number): ChatRequestError {
    if (status === 401 || status === 403) {
        return new ChatRequestError("access");
    }

    const errorCode = typeof payload === "object" && payload !== null && "error_code" in payload
        ? payload.error_code
        : undefined;

    if (errorCode === "content_filter") {
        return new ChatRequestError("contentFilter");
    }
    if (errorCode === "context_length_exceeded") {
        return new ChatRequestError("contextLength");
    }
    return new ChatRequestError("unexpected");
}

export async function chatRequestErrorFromResponse(response: Response): Promise<ChatRequestError> {
    let payload: unknown;
    try {
        payload = await response.json();
    } catch {
        // A gateway or network failure can return an empty or non-JSON body.
    }
    return chatRequestErrorFromPayload(payload, response.status);
}

export function chatRequestErrorKind(error: unknown): ChatRequestErrorKind {
    return error instanceof ChatRequestError ? error.kind : "unexpected";
}
